import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { navLabelFor } from '../Navigation';

const HOME_PATH = '/dashboard';

/** "Dashboard › <page>" trail; hidden on the dashboard itself and on unknown routes. */
const HeaderBreadcrumb: React.FC = () => {
  const { pathname } = useLocation();
  const label = navLabelFor(pathname);
  if (!label || pathname === HOME_PATH) return null;

  return (
    <Breadcrumbs
      separator={<ChevronRight sx={{ fontSize: 18 }} />}
      sx={{ fontSize: 14, color: 'text.secondary', '& .MuiBreadcrumbs-separator': { mx: 0.75 } }}
    >
      <Link
        component={RouterLink}
        to={HOME_PATH}
        underline="none"
        sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
      >
        Dashboard
      </Link>
      <Typography component="span" aria-current="page" sx={{ fontSize: 'inherit', fontWeight: 500, color: 'text.primary' }}>
        {label}
      </Typography>
    </Breadcrumbs>
  );
};

export default HeaderBreadcrumb;
